<template>
  <div class="card shadow-sm mb-4">
    <div class="card-header bg-accent">
      <h4 class="mb-0 text-white fs-1vw">تعیین وضعیت توانایی‌ها</h4>
    </div>
    <div class="card-body">
      <div class="row mb-3 justify-content-center">
        <div class="col-md-3 mb-3" :class="!selectedOverview ? 'col-md-6' : ''">
          <label class="form-label fw-bold">توانایی</label>
          <VSelect
              v-model="selectedAbility"
              :options="abilities"
              label="ability"
              placeholder="توانایی را انتخاب کنید"
              dir="rtl"
              @update:modelValue="toNull(['selectedOverview', 'selectedDetail'])">
            <template v-slot:no-options>
              توانایی یافت نشد!
            </template>
          </VSelect>
        </div>

        <div class="col-md-3 mb-3" :class="!selectedOverview ? 'col-md-6' : ''" v-if="selectedAbility">
          <label class="form-label fw-bold">تشریح</label>
          <VSelect
              v-model="selectedOverview"
              :options="selectedAbility.overviews"
              label="overview"
              placeholder="تشریح را انتخاب کنید"
              dir="rtl"
              @update:modelValue="handleOverviewChange">
            <template v-slot:no-options>
              تشریحی یافت نشد!
            </template>
          </VSelect>
        </div>

        <div class="col-md-3 mb-3" v-if="selectedOverview &&
         selectedOverview.details &&
          selectedOverview.details.length > 0 &&
          selectedOverview.details[0].property">
          <label class="form-label fw-bold">ویژگی</label>
          <VSelect
              v-model="selectedDetail"
              :options="selectedOverview.details"
              label="property"
              placeholder="ویژگی را انتخاب کنید"
              dir="rtl">
            <template v-slot:no-options>
              ویژگی یافت نشد!
            </template>
          </VSelect>
        </div>

        <div class="col-md-3 mb-3" v-if="selectedDetail">
          <label class="form-label fw-bold">وضعیت</label>

          <VSelect
              v-model="selectedDetail.status"
              :options="statuses.map(status => ({ label: status ? 'دارد' : 'ندارد', value: status }))"
              :reduce="option => option.value"
              label="label"
              placeholder="وضعیت را انتخاب کنید"
              dir="rtl"
              @update:modelValue="setStatus"
              v-if="selectedDetail.description">
            <template v-slot:no-options>
              وضعیتی یافت نشد!
            </template>
          </VSelect>

          <VSelect
              v-model="selectedDetail.level_status"
              :options="levelStatuses"
              placeholder="وضعیت را انتخاب کنید"
              dir="rtl"
              @update:modelValue="setLevelStatus"
              v-else-if="!selectedDetail.description">
            <template v-slot:no-options>
              سطحی یافت نشد!
            </template>
          </VSelect>
        </div>
      </div>

      <div class="row justify-content-center">
        <div class="col-md-6" v-if="selectedDetail && selectedDetail.description">
          <label class="form-label fw-bold">توضیحات</label>
          <textarea
              class="form-control"
              rows="4"
              disabled
              v-model="selectedDetail.description"
          ></textarea>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useToast } from "vue-toastification";
import VSelect from "vue-select";

export default {
  components: {
    VSelect,
  },
  created() {
    this.$store.dispatch("crudActions/fetchInitialData", {
      endpoint: "/competencies/abilities/index",
      afterMutation: "abilities/setAbilities",
    });
  },
  data() {
    return {
      selectedAbility: null,
      selectedOverview: null,
      selectedDetail: null,
      statuses: [true, false],
      levelStatuses: ["زیاد", "متوسط", "کم"],
    };
  },
  computed: {
    abilities: {
      get() {
        return this.$store.state.abilities.abilities;
      },
      set(value) {
        this.$store.commit("abilities/setAbilities", value);
      },
    },
  },
  methods: {
    toNull(data) {
      data.forEach((item) => (this[item] = null));
    },
    handleOverviewChange() {
      this.toNull(["selectedDetail"]);

      if (
          this.selectedOverview &&
          this.selectedOverview.details &&
          this.selectedOverview.details.length > 0
      ) {
        this.selectedDetail = this.selectedOverview.details[0];
      }
    },
    setStatus() {
      if (this.selectedDetail) {
        this.$store.dispatch("crudActions/create", {
          resourceData: {
            id: this.selectedDetail.id,
            status: this.selectedDetail.status,
          },
          endpoint: "/competencies/abilities/set-status",
        });
        useToast().success("وضعیت ثبت شد.");
      }
    },
    setLevelStatus() {
      if (this.selectedDetail) {
        this.$store.dispatch("crudActions/create", {
          resourceData: {
            id: this.selectedDetail.id,
            level_status: this.selectedDetail.level_status,
          },
          endpoint: "/competencies/abilities/set-level-status",
        });
        useToast().success("وضعیت ثبت شد.");
      }
    },
  },
};
</script>

<style scoped>
textarea {
  height: auto;
}
</style>
